<script setup>
import Popup from './popup.vue';
import { $vfm, VueFinalModal, ModalsContainer } from 'vue-final-modal';
</script>

<script>
export default {
  components: {
      Popup,
   },
  data: () => ({
    popupshow: false,
    meetingName:"",
    viewport: "",
    clientId: ""
  }),
  mounted() {
  },
  computed:{
  },
  methods: {
    saveMeeting: function() {
      console.log("got meeting name",this.meetingName);
      window.DevMgr.setMeeting(this.clientId,document.getElementById('meetingName').value);
      this.popupshow = false;
    },
    showPopUp : function(client,viewport,store) {
      console.log("====show pop up===="+this.popupshow);
      this.popupshow = true;
      this.viewport = viewport;
      this.clientId = client;
    }
  }
}
</script>

<template>
<v-button style="display:none;" @click="show = true">Open modal</v-button>
<Popup v-model="popupshow" >
  <template v-slot:title>Save Meetings</template>
  <template v-slot:content>
  <form class="formbox" >
    <div class="form-group" style="display:flex;">
      <span class="label-text">Meeting Name</span>
      <input type="text" name="meetingName" id="meetingName" class="input-text" v-model="meetingName"/>
    </div>
  </form>
  </template>
  <template v-slot:action>
     <button id="btn-submit" type="button" class="ButtonText" @click="saveMeeting">Submit</button>
  </template>
</Popup>
</template>

<style>
.label-text {
    padding: 0 50px;
    font-size: inherit;
    overflow: hidden;
    /*text-overflow: ellipsis;*/
    white-space: nowrap;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
}
.input-text {
  background-color: white;
  border: 1px solid lightgray;
  width: 100%;
  display: block;
}
.ButtonText{
    margin-left: 145px;
    height: 25px;
    background-color: #0072c5;
    color: #fff;
    white-space: nowrap;
    align-items: center;
    font-family: Roboto,Arial,Tahoma,Verdana,sans-serif!important;
    width:100%;
}

formbox{
  max-width:460px;
  margin:auto;
  margin-top:35px;
  border:0px solid #2f2f2f;
  padding:24px;
  border-radius:4px;
}
#btn-submit{
  width:100%;
}
</style>
